// Generated by purs version 0.14.4
import * as $foreign from "./foreign.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect_Console from "../Effect.Console/index.js";
import * as Restaumatic_Locales from "../Restaumatic.Locales/index.js";
var defaultLocale = Restaumatic_Locales.PL.value;
var getGlobalLocale = function __do() {
    var str = $foreign["_getGlobalLocale"]();
    var v = Restaumatic_Locales.fromText(str);
    if (v instanceof Data_Maybe.Nothing) {
        Effect_Console.log("WARNING: Invalid global locale: " + (Data_Show.show(Data_Show.showString)(str) + (". Defaulting to " + Data_Show.show(Restaumatic_Locales.showLocale)(defaultLocale))))();
        return defaultLocale;
    };
    if (v instanceof Data_Maybe.Just) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Restaumatic.I18nWrapper (line 20, column 3 - line 25, column 18): " + [ v.constructor.name ]);
};
export {
    getGlobalLocale
};
//# sourceMappingURL=index.js.map
